import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { getAdminAxios } from "../Services/customService";
import { API_LIVE_MARKET } from "../utils/api/ApiConstant";

const useBadlaInstrumentList = ({ allData }) => {
  // Fetch market data using react-query
  const { isLoading, data } = useQuery({
    queryKey: ["liveMarketData"],
    queryFn: async () => {
      const response = await getAdminAxios({
        url: API_LIVE_MARKET,
        params: {},
      });
      return response || []; // Ensure an array is returned
    },
  });

  // Ensure liveMarketData is always an array
  const liveMarketData = data ?? [];

  // Reusable function for filtering instrument options
  const getInstrumentOptions = (exchangeType) =>
    useMemo(() => {
      return liveMarketData
        .filter((x) => {
          const exchange = x.exchange?.toLowerCase();
          const name = x.name?.toLowerCase();
          const badlaType = allData?.badlaType?.toLowerCase();
          return exchangeType !== "dgcx"
            ? exchange === exchangeType && (!badlaType || badlaType === name)
            : exchange === exchangeType;
          // exchange === exchangeType
        })
        .map((val) => ({
          label: `${val.exchange} - ${val.name} - ${val.expiry}`,
          value: val.instrument_token,
          ...val,
        }));
    }, [liveMarketData, allData?.badlaType]);

  // Generate instrument options for each exchange
  const comexInstrumentOptions = getInstrumentOptions("comex") || [];
  const mcxInstrumentOptions = getInstrumentOptions("mcx") || [];
  const dgcxInstrumentOptions = getInstrumentOptions("dgcx") || [];

  return {
    isLoading,
    comexInstrumentOptions,
    mcxInstrumentOptions,
    dgcxInstrumentOptions,
    allInstrumentOptions: liveMarketData,
  };
};

export default useBadlaInstrumentList;
